import { cx } from "../../../styled-system/css";
import { styles } from "./ZoomButton.styles";
import { Icon, Icons } from "../Icon";

export interface ZoomButtonProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  currentScale: number;
  zoomInLabel: string;
  zoomOutLabel: string;
  zoomMaxScale: number;
  zoomInitScale: number;
}

export const ZoomButton = (props: ZoomButtonProps) => {
  const { onZoomIn, onZoomOut, currentScale, zoomInLabel, zoomOutLabel, zoomMaxScale, zoomInitScale } = props;
  const isZoomInActive = currentScale !== zoomMaxScale;
  const isZoomOutActive = currentScale > zoomInitScale;

  return (
    <div className={styles.buttonWrapper()} data-testid="zoom-button">
      <div className={styles.root(isZoomOutActive)}>
        <button
          disabled={!isZoomInActive}
          className={cx(styles.button(), styles.buttonZoomIn())}
          onClick={onZoomIn}
          aria-label={zoomInLabel}
        >
          <Icon icon={Icons.zoomIn} className={styles.icon(isZoomInActive)} />
        </button>
        <button
          disabled={!isZoomOutActive}
          className={cx(styles.button(), styles.buttonZoomOut())}
          onClick={onZoomOut}
          aria-label={zoomOutLabel}
        >
          <Icon icon={Icons.zoomOut} className={styles.icon(isZoomOutActive)} />
        </button>
      </div>
    </div>
  );
};
